/**
 * Cash-coin mark (U+1F7D8 NEGATIVE CIRCLED SQUARE): a filled circle with a square cutout, the
 * silhouette of a Chinese 方孔钱. Prefer the `HanCashCoin` icon in UI when a vector glyph is
 * available; this mark is for plain-text amounts (`formatHan`).
 */
export const HAN_CURRENCY_MARK = "\u{1F7D8}";

/**
 * The `HanCashCoin` icon's colour: the warm golden-orange of a Chinese cash coin (方孔钱), never the text colour,
 * wherever Han is shown (the wallets, the 红包 days).
 */
export const HAN_COIN_ICON_CLASS_NAME = "text-amber-600";

/** Locale-formatted Han amount without the currency mark. */
export function formatHanAmount(han: number): string {
  return Math.round(han).toLocaleString("en-US");
}

/** `🟘 1,234`. */
export function formatHan(han: number): string {
  return `${HAN_CURRENCY_MARK} ${formatHanAmount(han)}`;
}
